import React, { useEffect, useRef, useState } from "react";
import { ClockLoader } from "react-spinners";
import toast from "react-hot-toast";
import { load as loadCashfreeSdk } from "@cashfreepayments/cashfree-js";

const PaymentModal = ({ 
  paymentSessionId, 
  orderId, 
  onSuccess, 
  onFailure, 
  onClose 
}) => {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializePayment = async () => {
      try {
        // Load Cashfree SDK if not already loaded
        if (!window.Cashfree) {
          await loadCashfreeSdk({
            mode: process.env.NODE_ENV === 'production' ? 'production' : 'sandbox'
          });
        }

        const cf = new window.Cashfree();
        
        cf.checkout({
          paymentSessionId,
          redirectTarget: '_modal',
          onSuccess: (data) => {
            onSuccess({ ...data, orderId });
          },
          onFailure: (err) => {
            onFailure(err);
          },
          onClose: () => {
            onClose();
          }
        });

      } catch (error) {
        console.error('Payment initialization error:', error);
        toast.error('Failed to initialize payment');
        onFailure(error);
      } finally {
        setLoading(false);
      }
    };

    if (paymentSessionId) {
      initializePayment();
    }

    // Cleanup function
    return () => {
      if (window.Cashfree && window.Cashfree.checkout) {
        window.Cashfree.checkout.destroy();
      }
    };
  }, [paymentSessionId, orderId, onSuccess, onFailure, onClose]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md max-h-[90vh] overflow-auto">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold">
            {loading ? "Loading..." : "Complete Payment"}
          </h3>
          <button 
            onClick={onClose} 
            className="text-gray-500 hover:text-gray-700 text-2xl" 
            disabled={loading}
          >
            &times;
          </button>
        </div>
        
        {loading ? (
          <div className="text-center py-8">
            <ClockLoader size={40} />
            <p className="mt-4">Loading payment form...</p>
          </div>
        ) : (
          <div 
            ref={containerRef} 
            id="cashfree-dropin-container"
            className="min-h-[300px]"
          />
        )}
      </div>
    </div>
  );
};

export default PaymentModal;